module.exports = __webpack_public_path__ + "static/img/16.8e98319.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/16.jpg
// module id = giNw
// module chunks = 1